/**
 * Opções fechadas do formulário.
 *
 * São a fonte única da verdade para: as opções renderizadas no front,
 * a validação (Zod) no front e na API e os enums do Postgres.
 * Alterar um valor aqui exige gerar uma nova migration (`npm run db:generate`).
 */

export const TIPOS_FONTE = [
  'Página do Portal',
  'Carta de Serviços',
  'Legislação / norma',
  'Procedimento / manual',
  'Documento',
  'Sistema',
  'Base estruturada',
  'API',
  'Outro',
] as const;
export type TipoFonte = (typeof TIPOS_FONTE)[number];

export const SITUACOES_ATUALIZACAO = ['Sim', 'Parcialmente', 'Não', 'Não sei'] as const;
export type SituacaoAtualizacao = (typeof SITUACOES_ATUALIZACAO)[number];

export const NIVEIS_ACESSO = ['Pública', 'Interna', 'Precisa de autorização'] as const;
export type NivelAcesso = (typeof NIVEIS_ACESSO)[number];

export const SIM_NAO = ['Sim', 'Não'] as const;
export type SimNao = (typeof SIM_NAO)[number];

export const PAPEIS_PONTO_FOCAL = ['titular', 'suplente'] as const;
export type PapelPontoFocal = (typeof PAPEIS_PONTO_FOCAL)[number];
